/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import { USER_ROLE_FILTER_ALL, USER_SEARCH_MIN_LENGTH } from '../../../common/constants';

export const shouldFetchUsersSearch = (searchTerm, roleId) => {
  const trimmed = (searchTerm || '').trim();
  const hasSearch = trimmed.length >= USER_SEARCH_MIN_LENGTH;
  const hasRole = Boolean(roleId && roleId !== USER_ROLE_FILTER_ALL);
  return hasSearch || hasRole;
};

export const getUserSearchFetchParams = (searchTerm, roleId) => {
  const trimmed = (searchTerm || '').trim();
  const hasSearch = trimmed.length >= USER_SEARCH_MIN_LENGTH;
  const hasRole = Boolean(roleId && roleId !== USER_ROLE_FILTER_ALL);

  return {
    searchParams: hasSearch ? trimmed : '',
    roleId: hasRole ? String(roleId) : ''
  };
};

export const buildUsersSearchQueryString = (searchTerm, roleId) => {
  const { searchParams, roleId: roleParam } = getUserSearchFetchParams(searchTerm, roleId);
  const queryParams = new URLSearchParams();

  if (searchParams) {
    queryParams.set('searchInput', searchParams);
  }
  if (roleParam) {
    queryParams.set('roleId', roleParam);
  }

  return queryParams.toString();
};
